import { workflowSectionsToCreateDto } from './workflow-sections-to-create-dto.interface';

export interface UpdateWorkflowDto {
    name?: string;
    sectionsToCreate?: workflowSectionsToCreateDto[];
}
